// src/pages/BreadImprovers.js - Example Product Category Page
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';

import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import image10 from '../assets/images/product/image-10.jpg';

const BreadImprovers = () => {
  const products = [
    {
      name: "High-Quality Breads",
      category: "BREAD IMPROVERS",
      description: "Bake Diamond – formulated for traditional chakki atta (whole wheat) bread to improve its volume and softness.",
      features: [
        "Enhanced volume and softness for a superior eating experience",
        "Improved dough handling and machinability during production",
        "Extended shelf-life without compromising on freshness or taste"
      ],
      image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=600&h=400&fit=crop"
    },
    {
      name: "All-Purpose & Clean-Label",
      category: "IMPROVERS",
      description: "Clean-label bread improvers that meet modern consumer demands for natural ingredients while delivering exceptional results.",
      features: [
        "Natural enzyme systems for clean-label formulations",
        "Maintains dough consistency and product quality",
        "Suitable for organic and health-conscious product lines"
      ],
      image: "https://images.unsplash.com/photo-1517433670267-08bbd4be890f?w=600&h=400&fit=crop"
    },
    {
      name: "Specialty Breads",
      category: "BREAD IMPROVERS",
      description: "Tailored solutions for specialty bread varieties including multigrain, whole wheat, and artisan breads.",
      features: [
        "Optimized for whole grain and high-fiber formulations",
        "Maintains structure in specialty and artisan breads",
        "Enhances taste and texture in unique bread varieties"
      ],
      image: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=600&h=400&fit=crop"
    },
    {
      name: "Ethnic & Flatbreads",
      category: "IMPROVERS",
      description: "Specialized improvers for traditional Indian breads and flatbreads like naan, roti, and paratha.",
      features: [
        "Perfect pliability and softness for flatbreads",
        "Extended shelf-life for packaged Indian breads",
        "Maintains authentic texture and taste"
      ],
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop"
    },
    {
      name: "Gluten Reduction",
      category: "IMPROVERS",
      description: "Innovative solutions that allow reduction of gluten content while maintaining bread quality and structure.",
      features: [
        "Reduce gluten usage by up to 25% without compromising quality",
        "Cost-effective alternative to traditional formulations",
        "Maintains texture, volume, and shelf-life"
      ],
      image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&h=400&fit=crop"
    }
  ];

  const relatedCategories = [
    {
      title: "Premixes & Concentrates",
      description: "Simplify your process and ensure consistent results—every single time.",
      itemCount: 14,
      image: image2,
      link: "/products/premixes"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Keep your baked goods fresher, safer, and quality-assured for longer.",
      itemCount: 10,
      image: image3,
      link: "/products/shelf-life"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Smoother texture, softer crumbs, longer shelf life—made effortless.",
      itemCount: 8,
      image: image4,
      link: "/products/emulsifiers"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Rise to new heights—perfect volume and texture every time.",
      itemCount: 13,
      image: image5,
      link: "/products/leavening"
    },
    {
      title: "Specialty Enzymes",
      description: "Transform your dough quality and reduce dependency on chemical additives.",
      itemCount: 17,
      image: image6,
      link: "/products/enzymes"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "The finishing touch—functional bakery ingredients that enhance texture, flavor, and shelf-stability.",
      itemCount: 20,
      image: image7,
      link: "/products/other-ingredients"
    },
    {
      title: "Quality Assurance",
      description: "Consistent Quality. Guaranteed. Every Batch. Every Time.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "Explore our complete range of bakery ingredients and solutions.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Bread Improvers & Dough Conditioners"
      description="Our ENESSA BAKE improvers are specialty blends that enhance dough rheology, fermentation, and finished bread quality. They help you achieve greater loaf volume, finer crumb texture, and extended softness. We have improvers tailored for various applications."
      heroImage="https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&h=600&fit=crop"
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default BreadImprovers;

// To create other product pages, simply copy this file and change the data:
// - Premixes.js
// - ShelfLifeEnhancers.js
// - Emulsifiers.js
// - LeavingAgents.js
// - SpecialtyEnzymes.js
// - OtherIngredients.js
// - QualityAssurance.js